// @ts-ignore
import { tw } from "@careinfo/tailwind";
import { Control, FieldValues, Path, useController } from "react-hook-form";

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  placeholder?: string;
  autoFocus?: boolean;
  required?: boolean;
  disabled?: boolean;
}

export default function TextField<T extends FieldValues>({
  control,
  name,
  label,
  placeholder = "Enter text here...",
  required = false,
  autoFocus = false,
  disabled = false,
}: Props<T>) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <label className={tw`w-full `}>
      <span className={tw`block  text-[#272727]`}>
        {label}{" "}
        {required && <span className={tw`text-red-600 text-xl`}>*</span>}
      </span>
      <input
        {...field}
        type="text"
        id={name}
        disabled={disabled || false}
        autoFocus={autoFocus}
        placeholder={placeholder}
        className={tw`bg-[#EFF4F4] focus:outline-none p-2 mt-2 w-full rounded-sm `}
      />
      {error && (
        <span
          className={tw`text-red-500 text-xs flex items-center gap-x-1 mt-2`}
        >
          <span className={tw`block`}>{error.message}</span>
        </span>
      )}
    </label>
  );
}
